import { createSlice } from '@reduxjs/toolkit'

export const adSlice = createSlice({
    name: 'ads',
    initialState: {
        payload: {
            mcc: [],
            languages: [],
            countries: [],
            domains: [],
            adPhrase: [],
            limitCount: 10,
            waitingCount: 0,
            imgHashList: [],
            videoHashList: [],
        }
    },
    reducers: {
        updateMccData: (state, action) => {
            state.payload.mcc = action.payload.mcc;
        },
        updateLanguagesData: (state, action) => {
            state.payload.languages = action.payload.languages;
        },
        updateCountriesData: (state, action) => {
            state.payload.countries = action.payload.countries;
        },
        updateDomainsData: (state, action) => {
            state.payload.domains = action.payload.domains;
        },
        updateAdPhraseData: (state, action) => {
            state.payload.adPhrase = action.payload.adPhrase;
        },
        updateLimitCount: (state, action) => {
            state.payload.limitCount = action.payload.limitCount;
        },
        updateWaitingCount: (state, action) => {
            state.payload.waitingCount = action.payload.waitingCount;
        },
        updateImgHashList: (state, action) => {
            state.payload.imgHashList = action.payload.imgHashList;
        },
        updateVideoHashList: (state, action) => {
            state.payload.videoHashList = action.payload.videoHashList;
        },
    }
});

export const { updateMccData, updateLanguagesData, updateCountriesData, updateDomainsData, updateAdPhraseData, updateLimitCount, updateWaitingCount, updateImgHashList, updateVideoHashList } = adSlice.actions;

export default adSlice.reducer;